import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 14px 24px;
  padding: 4px 4px 4px 4px;

  border: 1px solid ${colors.titleStrongWhite};
  border-radius: 24px;

  @media (max-width: 498px) {
    margin: 10px 12px;
  }

`

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background-color: ${colors.titleStrongWhite};
  margin-right: 8px;

  border-radius: 50%;
  img {
    width: 18px;
    height: 18px;
  }
`

export const CompanyName = styled.div`
  color: ${colors.titleStrongWhite};
  font-family: Circular-Std;

  @media (max-width: 552px) {
    font-size: 14px;
    white-space: nowrap;
  }

  @media (max-width: 512px) {
    font-size: 12px;
    white-space: nowrap;
  }

  @media (max-width: 406px) {
    font-size: 10px;
    white-space: nowrap;
  }
`
